module.exports = __webpack_public_path__ + "img/check-circle.3a2235b7.svg";